import {s_ini} from "../_signals/s_ini";
import {s_results} from "../_signals/s_results";
import {ResultsAddMessage} from "../_messages/ResultsAddMessage";
import {CharacterFieldsUpdateMessage} from "../_messages/CharacterFieldsUpdateMessage";
import {s_char} from "../_signals/s_char";
import {CharacterNotesAddMessage} from "../_messages/CharacterNotesAddMessage";
import {CharacterNotesUpdateMessage} from "../_messages/CharacterNotesUpdateMessage";
import {CharacterTalentsAddMessage} from "../_messages/CharacterTalentsAddMessage";
import {CharacterTalentsUpdateMessage} from "../_messages/CharacterTalentsUpdateMessage";
import {CharacterSkillsAddMessage} from "../_messages/CharacterSkillsAddMessage";
import {CharacterModsAddMessage} from "../_messages/CharacterModsAddMessage";
import {CharacterModsUpdateMessage} from "../_messages/CharacterModsUpdateMessage";
import {CharacterModsDeleteMessage} from "../_messages/CharacterModsDeleteMessage";
import {
    msgTypeCharFieldsUpdate,
    msgTypeCharModsAdd,
    msgTypeCharModsDelete,
    msgTypeCharModsUpdate,
    msgTypeCharNotesAdd,
    msgTypeCharNotesUpdate,
    msgTypeCharSkillsAdd,
    msgTypeCharSkillsUpdate,
    msgTypeCharTalentsAdd,
    msgTypeCharTalentsUpdate,
    msgTypeIniClear, msgTypeResults,
    msgTypeResultsAdd,
    msgTypeResultsClear
} from "../_messages/MessageTypes";
import {CharacterSkillsUpdateMessage} from "../_messages/CharacterSkillsUpdateMessage";
import {s_chars} from "../_signals/s_chars";
import {IChar} from "../_interfaces/IChar";
import {remove_s_chars_mods, update_s_chars_mods} from "../_signals/s_chars_mods";
import {ResultsMessage} from "../_messages/ResultsMessage";
import {s_app_cid} from "../_signals/s_app";

export default function wsUpdates(data: any) {
    console.log('wsUpdates', data)
    if (data.hasOwnProperty('type') && data.type === msgTypeIniClear) {
        s_ini.value = [];
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeResultsClear) {
        s_results.value = [];
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeResults) {
        const msg = data as ResultsMessage;
        s_results.value = msg.payload.results;
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeResultsAdd) {
        const msg = data as ResultsAddMessage;
        s_results.value = [...s_results.value, msg.payload.result];
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeCharFieldsUpdate) {
        const msg = (data as CharacterFieldsUpdateMessage);
        // selfupdate if changes from are from sl
        if (msg.payload.cid === s_app_cid.value && msg.payload.sl) {
            let update = Object.fromEntries(msg.payload.fields.map(obj => [obj.k, obj.v]));
            s_char.value = {...s_char.value, ...update};
        }

        const cid = msg.payload.cid;
        const fields = msg.payload.fields
        const char = s_chars.value.get(cid);
        if (char) {
            const updated: IChar = {...char};
            for (let i = 0; i < fields.length; i++) {
                updated[fields[i].k] = fields[i].v;
            }
            s_chars.value.set(cid, updated);
            s_chars.value = new Map(s_chars.value);
        }
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeCharModsAdd) {
        const msg = (data as CharacterModsAddMessage);
        console.log('CharacterModsAddMessage', msg.payload)
        const mods = msg.payload.mods;
        update_s_chars_mods(mods)
        return;
    }
    if (data.hasOwnProperty('type') && data.type === msgTypeCharModsUpdate) {
        const msg = (data as CharacterModsUpdateMessage);
        console.log('CharacterModsUpdateMessage', msg.payload)
        const mods = msg.payload.mods;
        update_s_chars_mods(mods)
        return;
    }
    if (data.hasOwnProperty('type') && data.type === msgTypeCharModsDelete) {
        const msg = (data as CharacterModsDeleteMessage);
        console.log('CharacterModsDeleteMessage', msg.payload)
        const mods = msg.payload.mods;
        remove_s_chars_mods(mods)
        return;
    }

    console.log('data', data)
    if (data.payload.cid === s_app_cid.value && !data.payload.sl) return; // keine folgenden updates an mir selbst wenn sie nicht von der sl kommen....

    if (data.hasOwnProperty('type') && data.type === msgTypeCharNotesAdd) {
        const msg = (data as CharacterNotesAddMessage);
        console.log('TODO CharacterNotesAddMessage', msg.payload)
        // TODO
    }
    if (data.hasOwnProperty('type') && data.type === msgTypeCharNotesUpdate) {
        const msg = (data as CharacterNotesUpdateMessage);
        console.log('TODO CharacterNotesUpdateMessage', msg.payload)
        // TODO
    }
    if (data.hasOwnProperty('type') && data.type === msgTypeCharTalentsAdd) {
        const msg = (data as CharacterTalentsAddMessage);
        console.log('TODO CharacterTalentsAddMessage', msg.payload)
        // TODO
    }
    if (data.hasOwnProperty('type') && data.type === msgTypeCharTalentsUpdate) {
        const msg = (data as CharacterTalentsUpdateMessage);
        console.log('TODO CharacterTalentsUpdateMessage', msg.payload)
        // TODO
    }
    if (data.hasOwnProperty('type') && data.type === msgTypeCharSkillsAdd) {
        const msg = (data as CharacterSkillsAddMessage);
        console.log('TODO CharacterSkillsAddMessage', msg.payload)
        // TODO
    }
    if (data.hasOwnProperty('type') && data.type === msgTypeCharSkillsUpdate) {
        const msg = (data as CharacterSkillsUpdateMessage);
        console.log('TODO CharacterSkillsUpdateMessage', msg.payload)
        // TODO
    }
}